import * as tslib_1 from "tslib";
import FavoritesList from './FavoritesList';
import { observer } from 'mobx-react';
import { AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import { lazyToggleFavoritesTreeExpansion } from 'owa-mail-favorites-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-mail-strings';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import * as React from 'react';
var Favorites = /** @class */ (function (_super) {
    tslib_1.__extends(Favorites, _super);
    function Favorites() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (evt) {
            evt.stopPropagation();
            lazyToggleFavoritesTreeExpansion.importAndExecute();
        };
        _this.renderFavoriteRoot = function (isFavoritesTreeExpanded) {
            // We cannot use orderedFavoritesNodeIds here, because user might delete favorites on other client and the list hasn't been updated.
            // favoritesFolderNodes and favoritesPersonaNodes are the filtered nodes which represent the nodes that we could show.
            return (React.createElement(TreeNode, { chevronProps: { isExpanded: isFavoritesTreeExpanded, onClick: _this.onClick }, displayName: strings.favoritesHeaderText, depth: 0, isRootNode: true, isSelected: false, key: "favoritesRoot", onClick: _this.onClick, onContextMenu: _this.onRootNodeContextMenu }));
        };
        // We disable the context menu on the root.
        _this.onRootNodeContextMenu = function (evt) {
            evt.preventDefault();
        };
        _this.renderFavoritesList = function () {
            return React.createElement(FavoritesList, { key: "favoriteFolderList" });
        };
        return _this;
    }
    Favorites.prototype.render = function () {
        var ariaProps = {
            role: AriaRoles.tree,
        };
        var isFavoritesTreeExpanded = !getUserConfiguration().UserOptions
            .IsFavoritesFolderTreeCollapsed;
        return (React.createElement("div", tslib_1.__assign({ style: this.props.style, className: this.props.className }, generateDomPropertiesForAria(ariaProps)),
            this.renderFavoriteRoot(isFavoritesTreeExpanded),
            isFavoritesTreeExpanded && this.renderFavoritesList()));
    };
    Favorites = tslib_1.__decorate([
        observer
    ], Favorites);
    return Favorites;
}(React.Component));
export default Favorites;
//# sourceMappingURL=Favorites.js.map